import { render, staticRenderFns } from "./SelectProductImage.vue?vue&type=template&id=f0cc2dc2&scoped=true&"
import script from "./SelectProductImage.vue?vue&type=script&lang=js&"
export * from "./SelectProductImage.vue?vue&type=script&lang=js&"
import style0 from "./SelectProductImage.vue?vue&type=style&index=0&id=f0cc2dc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cc2dc2",
  null
  
)

export default component.exports